import { Controller } from 'react-hook-form';
import { Inputs } from 'components';
import { FormUploadSetImageStyled } from './styled';

const FormUploadSetImage = ({
  control,
  name,
  label,
  subLabel,
  errorMessage,
  ...rest
}) => (
  <FormUploadSetImageStyled>
    {(label || subLabel) && (
      <div className="lbl_g">
        {label && <div className="lbl_ca">{label}</div>}
        {subLabel && <div className="s_g_txt">{subLabel}</div>}
      </div>
    )}
    <Controller
      control={control}
      render={({ field }) => (
        <Inputs.UploadSetImage
          {...rest}
          {...field}
        />
      )}
      name={name}
    />
    {errorMessage && <div className="err_img">{errorMessage}</div>}
  </FormUploadSetImageStyled>
);

export default FormUploadSetImage;
